<b3-modal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    [heading]="viewModel.title"
    aria-level="2"
    icon="error"
    icon-tone="danger"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="emission-register-error-modal__description">{{ viewModel.description }}</p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="emission-register-error-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="onSupport()">
        <b3-icon name="support_agent" size="md"></b3-icon>
        Suporte B3
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onRetry()">
        <b3-icon name="sync" size="md" tone="on-brand"></b3-icon>
        Tentar Novamente
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
